import * as Sentry from "@sentry/nextjs";
import { OpenSeaPort } from "opensea-js";
import { OpenSeaAsset } from "opensea-js/lib/types";

export const getRefetechSingleAssetFunction =
  ({
    dispatch,
    seaport,
    tokenAddress,
  }: {
    dispatch: React.Dispatch<{
      type: string;
      payload: any;
    }>;
    seaport: OpenSeaPort;
    tokenAddress: string;
  }) =>
  async (tokenId: string, postId: string) => {
    dispatch({ type: "FETCH_START", payload: tokenId });
    try {
      const data: OpenSeaAsset = await seaport.api.getAsset({
        tokenAddress,
        tokenId,
      });
      const fetchedMintedAsset = data;
      dispatch({ type: "ADD_ASSET", payload: fetchedMintedAsset });
    } catch (err) {
      // if have error, continue fetching
      Sentry.captureException(err.message, {
        tags: { seaport: `post fetching error.`, postId },
      });
      // record the current fetch time
      dispatch({ type: "FETCH_FAIL", payload: tokenId });
    }
    return;
  };
